import React, { useState, useEffect, useRef } from "react";
import Navbar from "./Navbar";
import { motion } from "framer-motion";

const events = [
  {
    date: "27 JUNE 2026",
    title: "Chennai Event",
    description: "FRO EXPO 2026 Chennai",
    icon: "🌴",
    images: [
      "/images/chennai-2.jpg",
      "/images/chennai-3.jpg",
      "/images/chennai-4.jpg",
      "/images/chennai-5.jpg",
    ],
    side: "right"
  },
  {
    date: "17 MAY 2026",
    title: "Delhi Event",
    description: "Franchise Delhi Expo 2026",
    icon: "🏛️",
    images: [
      "/images/delhi-1.jpeg",
      "/images/delhi-2.jpeg",
      "/images/delhi-3.jpeg",
      "/images/delhi-4.jpeg",
      "/images/delhi-5.jpeg",
      "/images/delhi1.jpeg",
      "/images/delhi2.jpeg",
      "/images/delhi3.jpeg",
      "/images/delhi4.jpeg",
      "/images/delhi5.jpeg",
    
      "/images/delhi7.jpeg",
     
    ],
    side: "left"
  },
  {
    date: "10 OCT 2026",
    title: "Mumbai Event",
    description: "Franchise & Business Leadership Expo 2026 Mumbai",
    icon: "🏙️",
    images: [
      "/images/mumbai1.jpeg",
      "/images/mumbai2.jpeg",
      "/images/mumbai3.jpeg",
      "/images/mumbai4.jpeg",
      "/images/mumbai5.jpeg",
      "/images/mumbai6.jpeg",
      "/images/mumbai7.jpeg",
      "/images/mumbai8.jpeg",
      "/images/mumbai9.jpeg",
      "/images/mumbai10.jpeg",
      "/images/mumbai11.jpeg",
      "/images/mumbai12.jpeg",
      "/images/mumbai13.jpeg",
      "/images/mumbai14.jpeg",
    ],
    side: "right"
  },
  {
    date: "12 SEPT 2026",
    title: "Indore Tech Summit 2026",
    description: "Highlights from our participation in Indore Tech Summit 2026, including networking, industry discussions, recognition, and technology innovation.",
    icon: "🚀",
    images: [
      "/images/techs1.jpeg",
      "/images/techs2.jpeg",
      "/images/techs3.jpeg",
      "/images/techs4.jpeg",
      "/images/techs5.jpeg",
    ],
    side: "left"
  },
  {
    date: "8 JUNE 2026",
    title: "Campus Recruitment Drive",
    description: "Connecting talented students with meaningful career opportunities.",
    icon: "🎓",
    images: [
      "/images/campus-8.jpg",
      "/images/campus-3.jpg",
      "/images/campus-6.jpg",
      "/images/SV1.jpeg",
      "/images/SV2.jpeg",
      "/images/SV3.jpeg",
      "/images/SV4.jpeg"
    ],
    side: "right"
  },
  {
    date: "16 JUNE 2026",
    title: "Team Outing",
    description: "Team fun, bonding, and culture at Nakhrali Dhani Resort.",
    icon: "🖼️",
    images: [
      "/images/IMG_0923.JPG",
      "/images/IMG_0418.JPG",
      "/images/IMG_0751.JPG",
      "/images/IMG_0621.JPG",
      "/images/IMG_0635.JPG",
    ],
    side: "left"
  },
  {
    date: "10 JUN 2024",
    title: "Project Accomplishment",
    description: "A day away from screens to bond, relax and create unforgettable memories.",
    icon: "👥",
    images: ["/images/project-accomplishment.jpeg"],
    side: "right"
  },
  {
    date: "05 AUG 2024",
    title: "Excellence Award",
    description: "Honored our team for their dedication and delivering excellence.",
    icon: "🏆",
    images: [
      "/images/award-10.jpg",
      "/images/award-1.jpg",
      "/images/award-2.jpg",
      "/images/award-3.jpg",
      "/images/award-4.jpg",
      "/images/award-5.jpg",
      "/images/award-6.jpg",
      "/images/award-7.jpg",
      "/images/award-8.jpg",
      "/images/award-9.jpg",
      "/images/award-11.jpg",
    ],
    side: "left"
  },
];

function EventPhoto({ event, animDir }) {
  const [current, setCurrent] = useState(0);
  const hasMultiple = event.images.length > 1;
  const timerRef = useRef(null);

  useEffect(() => {
    if (!hasMultiple) return;
    timerRef.current = setInterval(() => {
      setCurrent((p) => (p + 1) % event.images.length);
    }, 3000);
    return () => clearInterval(timerRef.current);
  }, [hasMultiple, event.images.length]);

  const goTo = (i) => {
    setCurrent(i);
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setCurrent((p) => (p + 1) % event.images.length);
    }, 3000);
  };

  return (
    <motion.div
      className="timeline-photo-wrap"
      initial={{ opacity: 0, x: animDir }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <div className="slide-img-wrap">
        {event.images.map((src, i) => (
          <img
            key={i}
            src={src}
            alt={`${event.title} ${i + 1}`}
            className={`timeline-photo slide-img ${i === current ? "slide-img-active" : ""}`}
          />
        ))}
      </div>
      {hasMultiple && (
        <div className="slide-controls">
          <button className="slide-btn" onClick={() => goTo((current - 1 + event.images.length) % event.images.length)} aria-label="Previous">‹</button>
          <span className="slide-dots">
            {event.images.map((_, i) => (
              <span key={i} className={`slide-dot ${i === current ? "active" : ""}`} onClick={() => goTo(i)} />
            ))}
          </span>
          <button className="slide-btn" onClick={() => goTo((current + 1) % event.images.length)} aria-label="Next">›</button>
        </div>
      )}
    </motion.div>
  );
}

export default function Gallery() {
  return (
    <>
      <Navbar />
      <div className="gallery-page">
        {/* Hero */}
        <div className="gallery-hero">
          <span className="gallery-eyebrow">OUR JOURNEY</span>
          <h1 className="gallery-heading">Timeline <span className="gallery-heading-blue">Gallery</span></h1>
          <p className="gallery-subheading">A timeline of moments that define our growth, teamwork and achievements.</p>
          <div className="gallery-hero-divider" />
        </div>

        {/* Timeline */}
        <div className="timeline-container">
          <div className="timeline-line" />
          {events.map((event, index) => (
            <div key={index} className={`timeline-row ${event.side === "right" ? "timeline-row-right" : ""}`}>
              {/* Left side */}
              <div className="timeline-left">
                {event.side === "left" ? (
                  <motion.div
                    className="timeline-card"
                    initial={{ opacity: 0, x: -40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                  >
                    <span className="timeline-date">{event.date}</span>
                    <h3 className="timeline-title">{event.title}</h3>
                    <p className="timeline-desc">{event.description}</p>
                  </motion.div>
                ) : (
                  <EventPhoto event={event} animDir={-40} />
                )}
              </div>

              {/* Center icon */}
              <div className="timeline-center">
                <div className="timeline-icon">{event.icon}</div>
              </div>

              {/* Right side */}
              <div className="timeline-right">
                {event.side === "right" ? (
                  <motion.div
                    className="timeline-card"
                    initial={{ opacity: 0, x: 40 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                  >
                    <span className="timeline-date">{event.date}</span>
                    <h3 className="timeline-title">{event.title}</h3>
                    <p className="timeline-desc">{event.description}</p>
                  </motion.div>
                ) : (
                  <EventPhoto event={event} animDir={40} />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .gallery-page {
          background: #f4f6f9;
          min-height: 100vh;
          padding-bottom: 80px;
        }

        /* Hero */
        .gallery-hero {
          text-align: center;
          padding: 120px 20px 60px;
          background: #f4f6f9;
        }

        .gallery-eyebrow {
          display: inline-block;
          color: #2563eb;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 2px;
          text-transform: uppercase;
          margin-bottom: 14px;
        }

        .gallery-heading {
          font-size: 48px;
          font-weight: 800;
          color: #0f172a;
          margin: 0 0 14px;
          line-height: 1.15;
        }

        .gallery-heading-blue {
          color: #2563eb;
        }

        .gallery-subheading {
          font-size: 16px;
          color: #64748b;
          max-width: 520px;
          margin: 0 auto 20px;
          line-height: 1.7;
        }

        .gallery-hero-divider {
          width: 48px;
          height: 3px;
          background: #2563eb;
          border-radius: 4px;
          margin: 0 auto;
        }

        /* Timeline */
        .timeline-container {
          position: relative;
          max-width: 1100px;
          margin: 0 auto;
          padding: 20px 24px 40px;
        }

        .timeline-line {
          position: absolute;
          left: 50%;
          top: 0;
          bottom: 0;
          width: 2px;
          background: linear-gradient(to bottom, #2563eb, #93c5fd);
          transform: translateX(-50%);
          z-index: 0;
        }

        .timeline-row {
          display: grid;
          grid-template-columns: 1fr 80px 1fr;
          align-items: center;
          margin-bottom: 60px;
          position: relative;
          z-index: 1;
        }

        .timeline-left {
          display: flex;
          justify-content: flex-end;
          padding-right: 24px;
        }

        .timeline-right {
          display: flex;
          justify-content: flex-start;
          padding-left: 24px;
        }

        .timeline-center {
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 2;
        }

        .timeline-icon {
          width: 52px;
          height: 52px;
          background: #2563eb;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          box-shadow: 0 0 0 6px #dbeafe;
          z-index: 2;
        }

        .timeline-card {
          background: white;
          border-radius: 16px;
          padding: 24px 28px;
          max-width: 340px;
          width: 100%;
          box-shadow: 0 4px 20px rgba(0,0,0,0.07);
          transition: box-shadow 0.3s ease, transform 0.3s ease;
        }

        .timeline-card:hover {
          box-shadow: 0 8px 32px rgba(37,99,235,0.13);
          transform: translateY(-4px);
        }

        .timeline-date {
          display: block;
          font-size: 12px;
          font-weight: 700;
          color: #2563eb;
          letter-spacing: 1px;
          text-transform: uppercase;
          margin-bottom: 8px;
        }

        .timeline-title {
          font-size: 20px;
          font-weight: 700;
          color: #0f172a;
          margin: 0 0 10px;
        }

        .timeline-desc {
          font-size: 14px;
          color: #64748b;
          line-height: 1.7;
          margin: 0;
        }

        .timeline-photo {
          max-width: 340px;
          width: 100%;
          height: 210px;
          object-fit: cover;
          border-radius: 16px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.1);
        }

        /* Slider */
        .timeline-photo-wrap {
          max-width: 340px;
          width: 100%;
          position: relative;
        }

        .slide-img-wrap {
          position: relative;
          width: 100%;
          height: 210px;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0,0,0,0.1);
        }

        .slide-img {
          position: absolute;
          top: 0; left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 16px;
          opacity: 0;
          transition: opacity 0.7s ease;
        }

        .slide-img-active {
          opacity: 1;
        }

        .slide-controls {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-top: 10px;
        }

        .slide-btn {
          background: #2563eb;
          color: white;
          border: none;
          border-radius: 50%;
          width: 30px;
          height: 30px;
          font-size: 18px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 1;
          transition: background 0.2s ease;
        }

        .slide-btn:hover {
          background: #1d4ed8;
        }

        .slide-dots {
          display: flex;
          gap: 6px;
          align-items: center;
        }

        .slide-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #cbd5e1;
          cursor: pointer;
          transition: background 0.2s ease, transform 0.2s ease;
        }

        .slide-dot.active {
          background: #2563eb;
          transform: scale(1.3);
        }

        @media (max-width: 768px) {
          .timeline-container {
            padding: 20px 16px;
          }
          .timeline-row {
            grid-template-columns: 1fr;
            grid-template-rows: auto auto auto;
            gap: 16px;
            margin-bottom: 40px;
          }
          .timeline-line { display: none; }
          .timeline-left, .timeline-right {
            justify-content: center;
            padding: 0;
          }
          .timeline-center { justify-content: center; }
          .timeline-card, .timeline-photo { max-width: 100%; }
          .gallery-heading { font-size: 32px; }
        }
      `}</style>
    </>
  );
}